<template>
  <h3 class="pb5">Rapport par dénomination et numéro de série (CDX_0154)</h3>
  <CritereRechercheConsignation :cacherChampTypeConsignation="true" ref="critereRechercheConsignation"
                                :entiteDefault="entiteDefault" :siteDefault="siteDefault"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from "vuex";
import CritereRechercheConsignation from "@/components/rapports/Rechercher/CritereRechercheConsignation.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";

export default {
  name: "denominationNumeroSerieConsignationRapport",
  components: {CritereRechercheConsignation, ButtonBar},

  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consignation");
    this.isRechercheDataLoading = true;

    this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
      this.entiteDefault = res.data.entite;
      this.siteDefault = res.data.site;

      this.$store.dispatch('consignation/initialisationDecisionLibelleVOsDeCriteresAction').then((res) => {
        this.assignerResultat(res)
        this.isRechercheDataLoading = false;
      });
    });
  },

  data() {
    return {
      isRechercheDataLoading: false,
      consignations: [],
      entiteDefault: null,
      siteDefault: null,
    }
  },

  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },

  methods: {
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages
      this.$refs.critereRechercheConsignation.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheConsignation.getCritereRecherche();
      criteresRapportVO.titre = "denominationNumeroSerieConsignationRapport";
      criteresRapportVO.nomRapport = "consignation.DenominationNumeroSerieConsignationGenerateurRapport_CDX_0154";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRapportVO)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  }
}
</script>